import { useState } from "react";
import { useShowSnackbar } from "hooks/useShowSnackbar";
import { useSearchQueryParams } from "hooks/useSearchQueryParams";
import { useNavigate } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { GLOBAL_QUERY_PARAMS } from "constants/queryParams";
import { setDisplayNotification } from "services/storage";
import { saveNewPasswordRequest } from "./requests";
import { CHANGE_PASSWORD_MESSAGES } from "./constants";

export const useHandleChangePassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { addNotification, addPersistedNotification, removeNotification } =
    useShowSnackbar();
  const navigate = useNavigate();
  const queryParams = useSearchQueryParams();

  const saveNewPassword = async ({ password, passwordConfirmation }) => {
    removeNotification();
    setIsLoading(true);
    try {
      await saveNewPasswordRequest({
        passwordConfirmation,
        password,
        resetPasswordToken: queryParams.get(
          GLOBAL_QUERY_PARAMS.RESET_PASSWORD_TOKEN
        )
      });
      setDisplayNotification();
      addPersistedNotification({
        message: CHANGE_PASSWORD_MESSAGES.SUCCESS,
        variant: "success",
        persist: true
      });
      navigate(INTERNAL_PATHS.USER_LOG_IN);
    } catch (error) {
      addNotification({
        message: error.response.data.error_message,
        variant: "error",
        persist: true
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    saveNewPassword
  };
};
